import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.img = this.element.querySelector("img")
    if (!this.img) {
      this.finish()
      return
    }

    this.onLoad = () => this.finish()
    this.onError = () => this.finish()

    // complete covers both successful cache hits and already-failed images
    // (broken images often have naturalWidth 0 and will not fire load/error again).
    if (this.img.complete) {
      this.finish()
      return
    }

    this.img.addEventListener("load", this.onLoad)
    this.img.addEventListener("error", this.onError)
  }

  disconnect() {
    if (!this.img) return
    this.img.removeEventListener("load", this.onLoad)
    this.img.removeEventListener("error", this.onError)
  }

  finish() {
    this.element.classList.remove("is-loading")
    if (!this.img) return
    this.img.removeEventListener("load", this.onLoad)
    this.img.removeEventListener("error", this.onError)
  }
}
